import type { IconData } from '@stacksjs/iconify-core'

export const userGenderMale: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M22.855 1.525v1.52h4.57v1.52h1.53v4.58h1.52v-7.62z\"/><path fill=\"currentColor\" d=\"M25.905 4.565h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 9.14h1.52v7.62h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.52 15.24h1.52v3.05h-1.52Zm0-10.67h1.52v3.05h-1.52Zm0-3.04h1.52v1.52h-1.52Zm-1.53 16.76h1.53v1.52h-1.53Zm0-15.24h1.53v1.52h-1.53Zm-3.05 16.76h3.05v1.53h-3.05Zm0-18.28h3.05v1.52h-3.05Zm-7.61 19.81h7.61v1.52h-7.61Zm0-21.34h7.61v1.53h-7.61Zm-3.05 19.81h3.05v1.53h-3.05Zm0-18.28h3.05v1.52h-3.05Zm-1.53 16.76h1.53v1.52h-1.53Zm0-15.24h1.53v1.52h-1.53Zm-1.52 12.19h1.52v3.05h-1.52Zm0-10.67h1.52v3.05h-1.52Zm-1.52 3.05h1.52v7.62h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default userGenderMale
